var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "addUser",
    attrs: {
      "width": "900",
      "mask-closable": false,
      "title": $t("d76hme4", "新增成员")
    },
    on: {
      "on-cancel": _vm.clean
    },
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_vm.showNotice ? _c('Notice', {
    attrs: {
      "type": _vm.item.tagTarget
    }
  }) : _vm._e(), _c('Row', {
    staticClass: "content",
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v($t("rs7et37", "选择部门/成员"))]), _c('STree', {
    ref: "Tree",
    attrs: {
      "visible": _vm.modal.visible,
      "tag": _vm.item
    },
    on: {
      "changePush": _vm.onSelectChangeTree,
      "echoCheck": _vm.echoCheckDG
    }
  })], 1), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v($t("rttls58", "已选择部门/成员"))]), _c('OrgUserTagSelectList', {
    attrs: {
      "list": _vm.checkTree
    },
    on: {
      "remove": _vm.onDelete
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.clean
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.modal.loading
    },
    on: {
      "click": _vm.onCommit
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };